<template>
  <BaseDialog isOpen>
    <template v-slot:title>
      Are you sure you want to submit the offer for approval?
    </template>
    <template v-slot:body>
      <div class="secondary-text">
        Once approved, the conditional offer can be sent to the candidate
      </div>
    </template>
    <template v-slot:actions>
      <div>
        <PrimaryButton @click.native="cancel" text>
          Cancel
        </PrimaryButton>
        <PrimaryButton @click.native="handleSubmit" :loading="isLoading">
          Submit for Approval
        </PrimaryButton>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { createNamespacedHelpers } from "vuex";
import { OFFERS_NAMESPACE } from "@/store/modules/offers";
import { SUBMIT_OFFER_FOR_APPROVAL } from "@/store/modules/offers/actions";

const { mapActions } = createNamespacedHelpers(OFFERS_NAMESPACE);

export default {
  name: "SubmitForApprovalDialog",
  components: { PrimaryButton, BaseDialog },
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    currentOfferId() {
      return this.$route.params.id;
    }
  },
  methods: {
    ...mapActions({
      submitForApproval: SUBMIT_OFFER_FOR_APPROVAL
    }),
    async handleSubmit() {
      this.isLoading = true;
      await this.submitForApproval(this.currentOfferId);
      this.cancel();
      this.isLoading = false;
    },
    cancel() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
